import { UseMutateAsyncFunction, useMutation } from "@tanstack/react-query";
import axios from "axios";

import { DOMAIN_AUTH } from "../domain";

export const ACTION_LOGIN_WITH_SSO_TOKEN = "LOGIN_WITH_SSO_TOKEN";

export interface SsoLoginResponse {
  access_token: string;
  refresh_token: string;
}

const loginWithSsoToken = async (ssoToken: string): Promise<SsoLoginResponse> => {
  const response = await axios.post(
    `${import.meta.env.VITE_API_BASE_URL}/auth/sso/login`,
    {
      ssoToken,
    },
  );

  return response.data;
};

export const useLoginWithSsoToken = (): {
  loginWithSsoTokenAsync: UseMutateAsyncFunction<
    SsoLoginResponse,
    Error,
    string,
    unknown
  >;
  isSuccessLoginWithSsoToken: boolean;
  isPendingLoginWithSsoToken: boolean;
} => {
  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_AUTH, ACTION_LOGIN_WITH_SSO_TOKEN],
    mutationFn: loginWithSsoToken,
  });

  return {
    loginWithSsoTokenAsync: mutateAsync,
    isSuccessLoginWithSsoToken: isSuccess,
    isPendingLoginWithSsoToken: isPending,
  };
};
